var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutAdvanced3DFourUp = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 29,
  height: 18,
  viewBox: "0 0 29 18",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 16.2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.886 0H2a2 2 0 0 0-2 2v12.2a2 2 0 0 0 2 2h11.886V0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.886 0H25a2 2 0 0 1 2 2v6.5H13.886V0Z",
  fill: "#263A71"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.886 8.486H0V14.2a2 2 0 0 0 2 2h11.886V8.486ZM13.886 8.486H27V14.2a2 2 0 0 1-2 2H13.886V8.486Z"
}))));
export { SvgLayoutAdvanced3DFourUp as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-advanced-3d-four-up.svg";